import {
  TransportSitesResponseModel,
  TransportSiteApiModel,
} from './../models/transport-sites.model';
import { Injectable } from '@angular/core';
import { MwHttpService } from '@core/http';
import { MwLoadOptionsService } from './utils/load-options.service';
import { MwLoadOptions } from 'app/models/load-options.model';
import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class MwTransportSitesApiService {
  constructor(
    private http: MwHttpService,
    private loadOptionsService: MwLoadOptionsService
  ) {}

  load(options?: MwLoadOptions): Observable<TransportSitesResponseModel> {
    let query = options ? this.loadOptionsService.buildQuery(options) : '';
    query = query.length ? `?${query}` : query;
    return this.http.authGet<TransportSitesResponseModel>(
      `/integration/v1/Companies/{companyId}/TransportSites${query}`
    );
  }

  create(
    transportSite: TransportSiteApiModel
  ): Observable<TransportSiteApiModel> {
    return this.http.authPost<TransportSiteApiModel>(
      `/integration/v1/Companies/{companyId}/TransportSites`,
      {
        body: transportSite,
      }
    );
  }

  update(
    transportSite: TransportSiteApiModel
  ): Observable<TransportSiteApiModel> {
    return this.http.authPut<any>(
      `/integration/v1/Companies/{companyId}/TransportSites`,
      {
        body: transportSite,
      }
    );
  }

  delete(
    transportSite: TransportSiteApiModel
  ): Observable<TransportSiteApiModel> {
    return this.http.authDelete<TransportSiteApiModel>(
      `/integration/v1/Companies/{companyId}/TransportSites`,
      {
        body: transportSite,
      }
    );
  }

  deleteList(
    transportSites: TransportSiteApiModel[]
  ): Observable<TransportSiteApiModel> {
    return this.http.authDelete<any>(
      `/integration/v1/Companies/{companyId}/TransportSites/All`,
      {
        body: transportSites,
      }
    );
  }
}
